import { useQuery } from '@tanstack/react-query';
import type { BrandDto } from '@rw/shared';
import { api } from '../../lib/api';

export const brandKeys = { all: ['admin', 'brands'] as const };

/** Game owner: every brand (archived ones last). */
export const useBrands = (enabled = true) => useQuery({ queryKey: brandKeys.all, queryFn: () => api<BrandDto[]>('/admin/brands'), enabled });
